import React from 'react';

import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

import { toast } from 'react-toastify';

import { ApiContext } from '../../context/apicontext';
import { SessionContext } from '../../context/sessioncontext';

export const LogoutButton = (props) => {
	const Api = React.useContext(ApiContext);
	const userSession = React.useContext(SessionContext);

	const handleLogout = () => {
		if (userSession.session !== '') {
			toast(
				<React.Fragment>
					<Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' style={{ marginRight: '.3em' }} />
					Logging out...
				</React.Fragment>,
				{
					toastId: 'logoutToast'
				}
			);
			const headers = {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${userSession.session}`
			};
			Api.fetch('user/logout',
				{ headers },
				(result) => {
					toast.update('logoutToast', {
						render: 'Logged out!',
						type: toast.TYPE.INFO,
						autoClose: 2000
					});
				}
			);
			userSession.setSession('');
		}
	};

	return (
		<Button className='standard primary' onClick={handleLogout}>Log out</Button>
	);
};
